import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { PhitoNotification } from '../classes/PhitoNotification';
import { NotificationCenterService } from '../notification-center.service';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { PhitoDateUtils } from '../../../utils/phito-date-utils';
import { PhitoUtils } from '../../../utils/phito-utils';
import { NotificationService } from '../../../services/notification.service';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatHint } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatList } from '@angular/material/list';
import { PhitoToggleComponent } from '../../phito-toggle/phito-toggle.component';

@Component({
    selector: 'phito-notification-overview-list',
    templateUrl: './notification-overview-list.component.html',
    styleUrls: ['./notification-overview-list.component.scss'],
    imports: [
        MatIconButton,
        MatTooltip,
        MatIcon,
        MatFormField,
        MatLabel,
        MatInput,
        FormsModule,
        ReactiveFormsModule,
        MatHint,
        MatList,
        PhitoToggleComponent,
    ],
})
export class NotificationOverviewListComponent implements OnInit {
    private notificationCenterService = inject(NotificationCenterService);
    private notificationService = inject(NotificationService);

    @Input('notifications') notifications: PhitoNotification[] = [];
    @Output('notificationRead') notificationRead: EventEmitter<PhitoNotification> = new EventEmitter();

    onlyUnreadNotifications: boolean;
    searchCtrl: FormControl = new FormControl();

    ngOnInit(): void {
        this.searchCtrl.valueChanges.pipe(debounceTime(300), distinctUntilChanged()).subscribe(() => {
            this.search();
        });
    }

    markAsRead(notification: PhitoNotification) {
        //mark notifcation as read in list
        const foundNotification: PhitoNotification = this.notifications.find((n) => n.id === notification.id);
        if (foundNotification) {
            foundNotification.read = true;
        }
        this.notificationCenterService.markNotificationAsRead(notification).subscribe({
            next: (response) => {
                // console.log('READ NOTIFICATION', response);
            },
            error: (err) => {
                console.log('READ NOTIFICATION ERROR', err);
            },
        });
        this.notificationCenterService.fireNotificationClickEvent(notification);
    }

    getAcronym(notification: PhitoNotification) {
        //get first letter of first- and lastname
        return PhitoUtils.getAcronym(notification.createdBy);
    }

    formatDate(createdAt: Date) {
        return PhitoDateUtils.beautify(createdAt);
    }

    filterUnread(checked: boolean) {
        console.log('filterUnread');
        this.onlyUnreadNotifications = checked;
        if (checked) {
            this.notificationCenterService.getNotifications({ read: false }).subscribe({
                next: (response) => {
                    this.notifications = <PhitoNotification[]>response.data;
                },
            });
        } else {
            this.notificationCenterService.getNotifications().subscribe({
                next: (response) => {
                    this.notifications = <PhitoNotification[]>response.data;
                },
            });
        }
    }

    allRead() {
        return this.notifications.every((n) => n.read);
    }

    search() {
        const searchTxt = this.searchCtrl.value;
        this.notificationCenterService
            .getNotifications({
                read: this.onlyUnreadNotifications ? false : null,
                searchText: searchTxt
            })
            .subscribe({
                next: (response) => {
                    this.notifications = response.data;
                },
            });
    }

    markAllAsRead() {
        this.notificationCenterService.markAllNotificationAsRead().subscribe({
            next: () => {
                this.search();
            },
            error: (err) => {
                this.notificationService.errorMessagePut('Fehler!', err, null);
            },
        });
    }

    getDateString(notification) {
        return new Date(notification.createdAt).toLocaleDateString();
    }
}
